import { AppRouteProps } from "@bsm/component";
import { StudentListContainer } from "./container/StudentListContainer";

export const StudentListRoutes: Array<AppRouteProps> = [
    {
        path: '',
        element: <StudentListContainer />,
        children: []
    }
]